// removed by extract-text-webpack-plugin
module.exports = {"tooltipButton":"tooltipButton___3ZOCq","disabled":"disabled___3oqsp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tooltip/TooltipButton/index.scss
// module id = 110
// module chunks = 0